import React, { FC } from "react";
import { LoginPopup } from "src/page-components/auth/LoginPopup";
import { PasswordResetPopup } from "src/page-components/auth/PasswordResetPopup";
import { PasswordUpdatedPopup } from "src/page-components/auth/PasswordUpdatedPopup";
import { PasswordUpdatePopup } from "src/page-components/auth/PasswordUpdatePopup";
import { ModalState } from "src/hooks/useModal";

interface Props {
  loginModal: ModalState;
  passwordResetModal: ModalState;
  passwordUpdateModal: ModalState;
  passwordUpdatedModal: ModalState;
}

export const AuthPopups: FC<Props> = ({
  loginModal,
  passwordResetModal,
  passwordUpdateModal,
  passwordUpdatedModal,
}) => {
  return (
    <>
      <LoginPopup
        {...loginModal}
        onOpenPasswordResetPopup={passwordResetModal.openModal}
      />
      <PasswordResetPopup {...passwordResetModal} />
      <PasswordUpdatePopup
        {...passwordUpdateModal}
        onOpenPasswordUpdatedPopup={passwordUpdatedModal.openModal}
      />
      <PasswordUpdatedPopup {...passwordUpdatedModal} />
    </>
  );
};
